export const VOICE_MIME_CANDIDATES = [
  'audio/webm;codecs=opus',
  'audio/mp4;codecs=mp4a.40.2',
  'audio/mp4',
  'audio/webm',
  'audio/mpeg',
];

export const selectRecorderMimeType = () => {
  if (!window.MediaRecorder) return '';
  return VOICE_MIME_CANDIDATES.find((type) => window.MediaRecorder.isTypeSupported?.(type)) || '';
};

export const getVoiceEnvironment = () => {
  const ua = navigator.userAgent || '';
  const platform = navigator.userAgentData?.platform || navigator.platform || 'Unknown';
  const os = /Android/i.test(ua)
    ? 'Android'
    : /iPhone|iPad|iPod/i.test(ua)
      ? 'iOS/iPadOS'
      : /Mac/i.test(platform)
        ? 'macOS'
        : /Win/i.test(platform)
          ? 'Windows'
          : /Linux/i.test(platform)
            ? 'Linux'
            : 'Unknown';
  const browser = /SamsungBrowser/i.test(ua)
    ? 'Samsung Internet'
    : /FxiOS|Firefox/i.test(ua)
      ? 'Firefox'
      : /CriOS/i.test(ua)
        ? 'Chrome iOS'
        : /Chrome|Chromium/i.test(ua)
          ? 'Chrome'
          : /Safari/i.test(ua)
            ? 'Safari'
            : 'Unknown';

  const androidModel = ua.match(/Android[^;]*;\s*([^;)]+?)(?:\s+Build|\))/i)?.[1]?.trim();
  const deviceModel = androidModel || (/iPhone/i.test(ua) ? 'iPhone' : /iPad/i.test(ua) ? 'iPad' : navigator.userAgentData?.platform || platform);
  return {
    browser,
    os,
    device: navigator.userAgentData?.mobile || /Mobile|Android|iPhone|iPad/i.test(ua) ? 'Mobile/Tablet' : 'Desktop',
    deviceModel,
    userAgent: ua,
  };
};

export const getVoiceFeatures = () => ({
  getUserMedia: Boolean(navigator.mediaDevices?.getUserMedia),
  mediaRecorder: Boolean(window.MediaRecorder),
  audioContext: Boolean(window.AudioContext || window.webkitAudioContext),
  audioWorklet: Boolean(window.AudioWorkletNode),
  sharedArrayBuffer: Boolean(window.SharedArrayBuffer),
  offlineAudioContext: Boolean(window.OfflineAudioContext || window.webkitOfflineAudioContext),
  mediaStreamTrackProcessor: Boolean(window.MediaStreamTrackProcessor),
  speechRecognition: Boolean(window.SpeechRecognition || window.webkitSpeechRecognition),
});

export const extensionForMime = (mime = '') => {
  if (mime.includes('mp4')) return 'm4a';
  if (mime.includes('mpeg')) return 'mp3';
  return 'webm';
};
